import { useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CLEAR_WIDGETS_BY_ACTORID } from 'constants';
import { useKeyPress } from 'hooks';

/**
 * Hook that closes widgets related to the current actor when the Escape key is pressed.
 * Uses useRef to store the latest data and useKeyPress to handle the escape key.
 */
const useWidgetEscapeHandler = () => {
  const dispatch = useDispatch();
  const actorView = useSelector((state) => state.actorView);
  const widgets = useSelector((state) => state.widgets);

  const stateRef = useRef({
    actorId: actorView?.actorId,
    widgetsLength: widgets?.length,
  });

  useEffect(() => {
    stateRef.current = {
      actorId: actorView?.actorId,
      widgetsLength: widgets?.length,
    };
  }, [actorView?.actorId, widgets?.length]);

  const handleEscapeKey = useCallback(() => {
    const { actorId, widgetsLength } = stateRef.current;

    if (!actorId || widgetsLength === 0) {
      return;
    }

    dispatch({
      type: CLEAR_WIDGETS_BY_ACTORID,
      payload: { id: actorId },
    });
  }, [dispatch]);

  useKeyPress('Escape', handleEscapeKey);
};

export default useWidgetEscapeHandler;
